import React from "react";
import Header from './Header'
//import Header from './QuickcrateHeader'
import Footer from './Footer'
import { Outlet } from "react-router-dom";

const Layout = () =>{
    return(
        <>
            <Header/>
            <div className="page-content">
                <Outlet/>
            </div>
            <Footer/>
        </>
    )
};

export default Layout;